export enum Language {
  AR = 'ar',
  EN = 'en',
  ES = 'es',
  FR = 'fr',
  PT = 'pt'
}

export interface RequestError {
  response?: {
    status: number,
    data?: {
      error?: string
    }
  }
}

export interface DefaultError {
  code: string,
  message: string
}

export enum Events {
  LIVE_FORM_LOADED = 'LIVE_FORM_LOADED',
  LIVE_FORM_TRIGGER_SUBMIT = 'LIVE_FORM_TRIGGER_SUBMIT',
  LIVE_FORM_SAVED = 'LIVE_FORM_SAVED',
  LIVE_FORM_CANCEL = 'LIVE_FORM_CANCEL',
  LIVE_FORM_ERROR = 'LIVE_FORM_ERROR',
  LIVE_401_REQUEST_ERROR = 'LIVE_401_REQUEST_ERROR',
  LIVE_403_REQUEST_ERROR = 'LIVE_403_REQUEST_ERROR',
  LIVE_404_REQUEST_ERROR = 'LIVE_404_REQUEST_ERROR',
  LIVE_FETCH_USER_ERROR = 'LIVE_FETCH_USER_ERROR'
}

export enum Breakpoints {
  XS = 0,
  SM = 576,
  MD = 768,
  LG = 992,
  XL = 1200,
  XXL = 1700
}

